import Modal from 'react-modal';

import closeIcon from './icon-close.svg';
import Link from '../Link';

interface Props {
  children: JSX.Element;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
}

const ModalWindow: React.FC<Props> = (props: Props): JSX.Element => {
  Modal.setAppElement('.App');

  function close() {
    props.setIsOpen(false);
  }

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={close}
      style={{
        content: {
          position: 'fixed',
          zIndex: '100',
          inset: '40px',
          border: '1px solid rgb(204, 204, 204)',
          background: 'rgb(255, 255, 255)',
          overflow: 'auto',
          borderRadius: '4px',
          outline: 'none',
          padding: '20px',
        },
      }}
      overlayClassName='z-50'
      className='md:w-8/12 mx-auto h-fit'
    >
      <div className='z-50 '>
        <span className='flex justify-between'>
          <h2 className='text-xl mb-4'>{props.title}</h2>
          <Link href='#' onClick={close}>
            <img src={closeIcon} />
          </Link>
        </span>
        {props.children}
      </div>
    </Modal>
  );
};

export default ModalWindow;
